export default __webpack_public_path__ + "static/media/keto_giving_up@3x.4aa41aea.jpg";